import apiClient from '../../../Services/ApiClient';
import useNotification from '../../../Hooks/useNotification.hook';
import useTranslation from '../../../Hooks/useTranslation';
import useApiClient from '../../Base/Hooks/useApiClient';

export default function useSms() {
	const { showNotificationSuccess } = useNotification();
	const { t } = useTranslation();
	const { displayError } = useApiClient();

	const getText = async (caseId: string) => {
		try {
			const response = await apiClient.get(
				'/cases/' + caseId + '/notify-patient',
			);
			return response?.data?.content;
		} catch (e: any) {
			displayError(e);
		}
	};

	const sendSms = async (caseId: string) => {
		const response = await apiClient.post(
			'/cases/' + caseId + '/notify-patient',
			{},
		);

		if (!response.data?.error) {
			return true;
		}
	};
	return { sendSms, getText };
}
